export enum UserRoles {
  USER_ROLE_NUTZER = 'TNB_UFLA_rolle_nutzer',
  USER_ROLE_ADMIN = 'TNB_UFLA_rolle_admin',
  USER_ROLE_ACTUATOR = 'ROLE_UFLA_ACTUATOR'
}
